(function() {
  'use strict';

  class ShopTheLook {
    constructor(section) {
      this.section = section;
      this.currentIndex = 0;
      this.totalProducts = 0;

      // DOM refs
      this.hotspots = section.querySelectorAll('.horizon-shop-look__hotspot');
      this.products = section.querySelectorAll('.horizon-shop-look__product');
      this.dots = section.querySelectorAll('.horizon-shop-look__dot');
      this.prevBtn = section.querySelector('.horizon-shop-look__arrow--prev');
      this.nextBtn = section.querySelector('.horizon-shop-look__arrow--next');
      // 获取按钮元素
      this.shopNowLink = section.querySelector('#shop-now-link');

      this.totalProducts = this.hotspots.length;

      if (this.totalProducts === 0) return;

      // Init – 设置第一个产品的链接
      this.goTo(0);

      // Event listeners
      this.hotspots.forEach((hotspot, index) => {
        hotspot.addEventListener('click', () => this.goTo(index));
      });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Keyboard navigation
      this.section.addEventListener('keydown', (e) => {
        if (e.target.closest('.horizon-shop-look__hotspot') ||
            e.target.closest('.horizon-shop-look__dot') ||
            e.target.closest('.horizon-shop-look__arrow')) {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prev();
          }
        }
      });
    }

    goTo(index) {
      if (index === this.currentIndex) return;
      if (index < 0) index = this.totalProducts - 1;
      if (index >= this.totalProducts) index = 0;

      // Update hotspots
      this.hotspots.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-expanded', i === index);
      });

      // Update products
      this.products.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('role', 'tabpanel');
      });

      // Update dots
      this.dots.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-selected', i === index);
      });

      // ====== 更新 "Shop now" 按钮链接 ======
      const currentProductEl = this.products[index];
      if (currentProductEl && this.shopNowLink) {
        // 优先使用产品图片链接，其次使用标题链接
        const linkEl = currentProductEl.querySelector('.horizon-shop-look__product-image') ||
                       currentProductEl.querySelector('.horizon-shop-look__title a');
        if (linkEl) {
          this.shopNowLink.href = linkEl.href;
          this.shopNowLink.style.display = 'inline-flex'; // 显示按钮
        } else {
          // 如果当前产品不可用或未选择，隐藏按钮
          this.shopNowLink.style.display = 'none';
        }
      }

      this.currentIndex = index;
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }
  }

  // ============================================================
  // Shopify Theme Editor – Section reload handling
  // ============================================================

  function initSection(section) {
    section._shopTheLook = new ShopTheLook(section);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.horizon-shop-look').forEach((section) => {
      initSection(section);
    });
  });

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section.classList.contains('horizon-shop-look')) {
        initSection(section);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target;
      if (section._shopTheLook) {
        delete section._shopTheLook;
      }
    });
  }
})();